<template>
  <div class="k-table-filters">
    <div class="k-table-filters-container">
      <div class="k-table-filters-content">
        <div
          v-for="key in shownKeys"
          :key="key"
          class="k-table-filter-item"
          v-show="headers[key].hasDropdown || headers[key].hasMultiSelectDropdown || headers[key].filterable"
        >
          <div class="k-table-filter-input">
            <template v-if="headers[key].hasMultiSelectDropdown">
              <k-dropdown-multi-select
                :id="`filter-${key}`"
                class="dropdown dark"
                :options="uniqueDropdownOptions[key] || []"
                :placeholder="headers[key].name"
                :model-value="dropdownFilters[key]"
                @update:modelValue="onDropdownFilterChange(key, $event)"
              />
            </template>
            <template v-else-if="headers[key].hasDropdown">
              <k-dropdown
                :id="`filter-${key}`"
                class="dropdown dark"
                :showSearch="false"
                :clearOption="true"
                :options="uniqueDropdownOptions[key] || []"
                :placeholder="headers[key].name"
                :model-value="dropdownFilters[key]"
                @update:modelValue="onDropdownFilterChange(key, $event)"
              />
            </template>
            <template v-else>
              <div class="table-search">
                <label :for="`table-search-input-${key}`">
                  <input
                    :id="`table-search-input-${key}`"
                    type="text"
                    class="form-control search-input ph-no-capture"
                    :value="searchFilters[key]"
                    @input="onSearchFilterChange(key, $event.target.value)"
                  >
                </label>
                <button
                  type="submit"
                  aria-label="Submit search"
                  title="Submit search"
                >
                  <span class="fa fa-search" aria-hidden="true"></span>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KDropdown from '../../k-dropdown.vue';
import KDropdownMultiSelect from '../../k-dropdown-multi-select.vue';

export default {
  components: {
    KDropdown,
    KDropdownMultiSelect,
  },

  props: {
    headers: Object,
    shownKeys: Array,
    uniqueDropdownOptions: Object,
    dropdownFilters: Object,
    searchFilters: Object,
    onReset: Function,
    onDropdownFilterChange: Function,
    onSearchFilterChange: Function,
  },
};
</script>
